/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SmsAutoDisableStatus
 */
export interface SmsAutoDisableStatus {
    /**
     * 
     */
    disabled_at: string;
    /**
     * 
     */
    failure_class: string;
    /**
     * 
     */
    provider_response: string;
}

/**
 * Check if a given object implements the SmsAutoDisableStatus interface.
 */
export function instanceOfSmsAutoDisableStatus(value: object): value is SmsAutoDisableStatus {
    if (!('disabled_at' in value) || value['disabled_at'] === undefined) return false;
    if (!('failure_class' in value) || value['failure_class'] === undefined) return false;
    if (!('provider_response' in value) || value['provider_response'] === undefined) return false;
    return true;
}

export function SmsAutoDisableStatusFromJSON(json: any): SmsAutoDisableStatus {
    return SmsAutoDisableStatusFromJSONTyped(json, false);
}

export function SmsAutoDisableStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsAutoDisableStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'disabled_at': json['disabled_at'],
        'failure_class': json['failure_class'],
        'provider_response': json['provider_response'],
    };
}

export function SmsAutoDisableStatusToJSON(json: any): SmsAutoDisableStatus {
    return SmsAutoDisableStatusToJSONTyped(json, false);
}

export function SmsAutoDisableStatusToJSONTyped(value?: SmsAutoDisableStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'disabled_at': value['disabled_at'],
        'failure_class': value['failure_class'],
        'provider_response': value['provider_response'],
    };
}

